module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAABKElEQVQ4T62UP0sDQRDF39yftFbeJdj7ARQsre1Ewc5GxEZFIY1eith5p4VgKUpSip2fwU6/ho0XEAvBgLe7TxK4S0SMe/G2WoY3P2aYNyPI3wbdYFFfCrEJcKaI//EhoAR4NEpvSa4NTz93KNIGsO2Cr9Ywx3dpdJNgYwSL1TWIftryDmxBua5+xiUa/VDAglh1BXxLI79ZFtY454Ix+mkMlp2AeO+1/IvfYPVE75Hsp5HXGdf8gNlUMxtnKw5wT+Fh77h2ledMBRskh4laBXEHYD+NvJtBbGrYMDlWawa4BcxuGtU6BSxIsrZQ5mza/K7hMoB5iKw7jvs8HEClsPIVTWizLKyyAVhbI4jtTAvhx8uR151o2krXKfz3oqvRold6glDBcfwCG47gZmxO9CEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shape.png
// module id = PN7j
// module chunks = 1